export enum MakeUpCreditMode {
    None,
    Allow,
    Expired
}
